var _style, _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraphicGuide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-277 404.9 40 25.9",
    style: {
      enableBackground: "new -277 404.9 40 25.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#092833;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -269.8,
    y: 413.8,
    className: "st0",
    width: 25.5,
    height: 2.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -269.8,
    y: 419.3,
    className: "st0",
    width: 25.5,
    height: 2.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-237.9,405.8c-0.6-0.6-1.3-0.9-2.1-0.9h-34c-0.8,0-1.5,0.3-2.1,0.9c-0.6,0.6-0.9,1.3-0.9,2.1v19.9 c0,0.8,0.3,1.5,0.9,2.1c0.6,0.6,1.3,0.9,2.1,0.9h34c0.8,0,1.5-0.3,2.1-0.9c0.6-0.6,0.9-1.3,0.9-2.1v-19.9 C-237,407.1-237.3,406.4-237.9,405.8z M-274,427.8v-19.9h34v19.9H-274z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicGuide);
export default __webpack_public_path__ + "static/media/graphic_guide.07dff359567ee1b13fe1b6210f3a0990.svg";
export { ForwardRef as ReactComponent };